import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames/bind";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// reactstrap components
import { NavbarBrand, NavItem, NavLink, Nav, Container } from "reactstrap";

class DefaultNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      navbarExpanded: false
    };

    this.navbar = React.createRef();

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.closeNavbar = this.closeNavbar.bind(this);
  }

  toggleNavbar() {
    this.setState(prevState => ({
      navbarExpanded: !prevState.navbarExpanded
    }));
  }

  closeNavbar() {
    this.setState({
      navbarExpanded: false
    });
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const navigation = this.navbar.current;
    const navTop = navigation.offsetTop + navigation.offsetHeight;

    if (window.scrollY >= navTop) {
      navigation.classList.add("navbar-sticky");
    } else {
      navigation.classList.remove("navbar-sticky");
    }
  };

  render() {
    const useOnlyDarkLogo = this.props.useOnlyDarkLogo;

    return (
      <nav
        ref={this.navbar}
        className={classNames(
          "navbar navbar-expand-md main-nav navigation fixed-top sidebar-left",
          { "navbar-expanded": this.state.navbarExpanded }
        )}
      >
        <Container>
          {/* <button
            className="navbar-toggler"
            type="button"
            onClick={this.toggleNavbar}
          >
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </button> */}

          <NavbarBrand className="mr-lg-5" to="/" tag={Link}>
            {useOnlyDarkLogo ? (
              <img
                alt="..."
                src={require("assets/img/logo.png")}
                className="logo logo-sticky"
              />
            ) : (
              <>
                <img
                  src={require("assets/img/logo.png")}
                  alt="Laapp"
                  className="logo logo-sticky d-block d-md-none"
                />
                <img
                  src={require("assets/img/logo-light.png")}
                  alt="Laapp"
                  className="logo d-none d-md-block"
                />
              </>
            )}
          </NavbarBrand>

          <a
            href="https://wa.me/85252860623/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faWhatsapp} size="2x" color="green" className="d-block d-sm-none" style={{ cursor: 'pointer' }} />
          </a>

          <div className="collapse navbar-collapse">
            {/* <div className="sidebar-brand">
              <Link to="/">
                <img
                  src={require("assets/img/logo.png")}
                  alt="Laapp Template"
                  className="logo"
                />
              </Link>
            </div> */}

            <Nav className="nav navbar-nav ml-auto" navbar>
              {/* <NavItem>
                <NavLink href="#!">Home</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#!">About</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#!">Product</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#!">Pricing</NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink style={{cursor: 'pointer'}} onClick={() => {
                  // this.toggleNavbar()
                  this.props.handleClick()}
                }>聯絡客服</NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink href="#!" onClick={()=>this.props.handleClick()} className="btn btn-rounded btn-alternate mr-2 mr-md-5">
                  <span style={{color: 'white'}}>聯絡客服{" "}</span>
                </NavLink>
              </NavItem> */}
            </Nav>
          </div>
        </Container>
      </nav>
    );
  }
}

export default DefaultNavbar;
